// action
import {
    SAVE_TEST_MASTER,
    SAVE_TEST_MASTER_FAIL,
    SAVE_TEST_MASTER_SUCCESS,
    SAVE_TEST_MASTER_RESET
} from '../action/saveTestMasterAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_TEST_MASTER:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_TEST_MASTER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_TEST_MASTER_SUCCESS:
            return {
                ...state,
                apiState: "success"
            }
        case SAVE_TEST_MASTER_RESET:
            return initialState
        default:
            return state
    }
}